// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1ijE9","title":"AfterFrontImage_title__3sJKa"};